import styled from 'styled-components';

export const ModalText = styled.p`
  padding: 0 0 0.875rem;
`;
